export default __webpack_public_path__ + "static/media/no_img.1d3abbb6.png";